import { Builder, BuilderBlocks } from "@builder.io/react";
import TextCarousel from "@components/RedesignComponents/TextCarousel";
import { TextCarouselType } from "@components/RedesignComponents/types/VerticalTabTypes";
import { segmentTrack } from "@utils/segment/segment-track";
import React from "react";

const TextCarouselWrapper: React.FC<TextCarouselType> = ({
  eyebrowText,
  ctaCopy,
  ctaLink,
  specialtyList,
  ctaUrl,
  openInNewTab,
  ...props
}) => {
  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    const url = new URL(e.currentTarget.href);

    if (e.currentTarget.classList.contains("text--carousel--marketing-link")) {
      segmentTrack("Link Clicked", {
        url: window.location.pathname,
        text: e.currentTarget.text,
        target: url.pathname,
        initiator: "User",
        object: "Link",
        action: "Clicked",
        source_application: "Marketing",
      });
    } else {
      segmentTrack("Marketing CTA Clicked", {
        url: window.location.pathname,
        text: e.currentTarget.text,
        target: url.pathname,
        initiator: "User",
        object: "Marketing CTA",
        action: "Clicked",
        source_application: "Marketing",
      });
    }
  };

  return (
    <TextCarousel
      eyebrowText={eyebrowText}
      ctaCopy={ctaCopy}
      ctaLink={ctaLink}
      specialtyList={specialtyList}
      ctaUrl={ctaUrl}
      openInNewTab={openInNewTab}
      onClick={onClick}
      BuilderBlocksComponent={BuilderBlocks}
      {...props}
    />
  );
};

export default TextCarouselWrapper;

export const RegisterVerticalTab = () => {
  Builder.registerComponent(TextCarouselWrapper, {
    name: "vertical-tab",
    inputs: [
      {
        name: "eyebrowText",
        type: "string",
      },
      {
        name: "ctaCopy",
        type: "string",
      },
      {
        name: "openInNewTab",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "ctaLink",
        type: "reference",
        model: "page",
      },
      {
        name: "ctaUrl",
        type: "string",
      },
      {
        name: "specialtyList",
        type: "list",
        subFields: [
          {
            name: "title",
            type: "string",
          },
          {
            name: "openInNewTab",
            type: "boolean",
            defaultValue: false,
          },
          {
            name: "ctaLink",
            type: "reference",
            model: "page",
          },
          {
            name: "ctaUrl",
            type: "string",
          },
          {
            name: "mobileCtaCopy",
            type: "string",
          },
          {
            name: "image",
            type: "file",
          },
          {
            name: "mobileImage",
            type: "file",
          },
          {
            name: "imageAltText",
            type: "longText",
          },
          {
            name: "subCopy",
            type: "longText",
          },
          {
            name: "topImageSlot",
            type: "uiBlocks",
            defaultValue: [],
          },
          {
            name: "bottomImageSlot",
            type: "uiBlocks",
            defaultValue: [],
          },
        ],
      },
    ],
  });
};
